import React from 'react'
import { l } from '@manychat/manyui'

const WATurnedOffNotification = () => {
  return <span>{l.translate('Whatsapp channel was turned off')}</span>
}

export default WATurnedOffNotification
